module.exports = __webpack_public_path__ + "img/icon_Region.7c017fc9.svg";